
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tt-links/[deepLinkId]",
      function () {
        return require("private-next-pages/tt-links/[deepLinkId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tt-links/[deepLinkId]"])
      });
    }
  